import { render, staticRenderFns } from "./cancelledlist.vue?vue&type=template&id=1b19b03e&scoped=true"
import script from "./cancelledlist.vue?vue&type=script&lang=js"
export * from "./cancelledlist.vue?vue&type=script&lang=js"
import style0 from "./cancelledlist.vue?vue&type=style&index=0&id=1b19b03e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b19b03e",
  null
  
)

export default component.exports